/**
 * Ayuda — Comercial → Precios
 */

/** @type {import('../help-index.js').HelpSidebarItem} */
export const ADM_COM_PRICES_ITEM = {
  id: 'prices',
  screenId: 'adm-com-prices',
  label: 'Precios',
  description: 'Listas de precios para ventas.',
  detail: {
    sections: [
      {
        title: 'Para qué sirve',
        intro:
          'Las listas de precios agrupan los valores de venta de tus productos. Cada cliente puede tener una lista asignada; la terminal de ventas también usa una lista configurada.',
      },
      {
        title: 'Ver las listas',
        bullets: [
          'Columnas: Descripción, Moneda.',
          'Tocá una fila para ver los precios de esa lista.',
          'Lápiz — editar lista y precios por artículo.',
          'Cruz — eliminar la lista (con confirmación).',
        ],
      },
      {
        title: 'Crear una lista nueva',
        fields: [
          { label: 'Descripción', description: 'Nombre de la lista (por ejemplo «Minorista»). Obligatorio.' },
          { label: 'Moneda', description: 'Moneda en la que están expresados los precios.' },
          {
            label: 'Precios con IVA incluido',
            description: 'Si tu empresa es Responsable Inscripto, podés elegir si los precios incluyen IVA o son netos.',
          },
        ],
      },
      {
        title: 'Editar precios de una lista',
        intro: 'Al editar una lista ves todos los artículos con precio cargado:',
        bullets: [
          'Agregar artículo — buscá un producto y asignale precio.',
          'Ajuste porcentual — subí o bajá todos los precios un porcentaje.',
          'Modificá el «Nuevo precio» de cada fila y guardá los cambios.',
        ],
      },
    ],
  },
}
